"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  var onFinish = function onFinish() {};
  var onFinishFailed = function onFinishFailed() {};
  return /*#__PURE__*/_react.default.createElement(_antd.Form, {
    name: "basic",
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 16
    },
    initialValues: {
      remember: true
    },
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    autoComplete: "off"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Username",
    name: "username",
    rules: [{
      required: true,
      message: 'Please input your username!'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, null)), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Password",
    name: "password",
    rules: [{
      required: true,
      message: 'Please input your password!'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input.Password, null)), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "remember",
    valuePropName: "checked",
    wrapperCol: {
      offset: 8,
      span: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, null, "Remember me")), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    wrapperCol: {
      offset: 8,
      span: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit"
  }, "Submit")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError', 'controlOutline', 'colorErrorBorder', 'colorErrorHover'],
  key: 'default'
};
var _default = exports.default = componentDemo;